import axios from "axios";
import {
    ADD_NEW_CERT,
    ADD_NEW_SKILL,
    ADD_NEW_SKILL_TYPE,
    ADD_NEW_USER,
    ADMIN_DASHBOARD,
    DELETE_CERT,
    DELETE_SKILL,
    DELETE_SKILL_TYPE,
    DELETE_USER,
    GET_ROLES,
    GET_USERS, MERGE_CERTS, MERGE_SKILLS,
    UPDATE_CERT,
    UPDATE_SKILL,
    UPDATE_SKILL_TYPE,
    UPDATE_USER,
} from "./RestCatalog";

const addNewSkill = (payload) => {
    return axios.post(ADD_NEW_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateSkill = (payload) => {
    return axios.post(UPDATE_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteSkill = (payload) => {
    return axios.post(DELETE_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const mergeSkills = (payload) => {
    return axios.post(MERGE_SKILLS, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const addNewSkillType = (payload) => {
    return axios.post(ADD_NEW_SKILL_TYPE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateSkillType = (payload) => {
    return axios.post(UPDATE_SKILL_TYPE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteSkillType = (payload) => {
    return axios.post(DELETE_SKILL_TYPE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const addNewCert = (payload) => {
    return axios.post(ADD_NEW_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateCert = (payload) => {
    return axios.post(UPDATE_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}
const deleteCert = (payload) => {
    return axios.post(DELETE_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const mergeCerts = (payload) => {
    return axios.post(MERGE_CERTS, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const addNewUser = (payload) => {
    return axios.post(ADD_NEW_USER, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUser = (payload) => {
    return axios.post(DELETE_USER, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUser = (payload) => {
    return axios.post(UPDATE_USER, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getRoles = () => {
    return axios.get(GET_ROLES)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getUsers = () => {
    return axios.get(GET_USERS)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getAdminDashboard = () => {
    return axios.get(ADMIN_DASHBOARD)
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

export {
    addNewSkill,
    updateSkill,
    deleteSkill,
    mergeSkills,
    addNewSkillType,
    updateSkillType,
    deleteSkillType,
    addNewCert,
    updateCert,
    deleteCert,
    mergeCerts,
    addNewUser,
    deleteUser,
    updateUser,
    getRoles,
    getUsers,
    getAdminDashboard,
};